import urlParse from './urlParse'
import aLiurlParse from './aLiurlParse'
// import appId from '../config/appId'
import auth from './authSaobei'
import env from '../config/env'
import store from '../store/index'
import axios from '../request/http'
const getUserAuth = (code, source, openid) => {
  return axios.post(`/user/h5/auth`, {'jscode': code, source, openid});
}
const login = () => {
  return new Promise((resolve, reject) => {
    let userToken = store.state.userToken
    console.log('login-----userToken', userToken)
    if (env === 'dev') { // env === 'dev'
      // 开发环境下模拟登录
      if (!userToken) {
        store.commit('userInfo', {})
      }
    } else {
      if (!userToken) { // 未微信授权
        let source = 0
        if (window.isWeixin) {
          source = 2
          let hash = decodeURIComponent(window.location.hash)
          let urlObj = aLiurlParse(hash)
          let code = urlObj.code || ''
          let openid = urlObj.openid || ''
          let brandIdStr = urlObj.brandId || ''
          let storeIdStr = urlObj.storeId || ''
          let linkNO = urlObj.linkNO || ''
          let amount = urlObj.amount ? (urlObj.amount / 100) : ''
          store.commit('linkNO', linkNO)
          store.commit('amount', amount)
          store.commit('brandIdStr', brandIdStr)
          store.commit('storeIdStr', storeIdStr)
          // 扫贝 获取url openid
          console.log('urlParse-----linkNO', linkNO)
          console.log('urlParse-----amount', amount)
          console.log('urlParse-----code', code)
          if (code || openid) {
            getUserAuth(code, source, openid).then((res) => {
              console.log('code', res)
              const { userToken, openId } = res.data
              console.log('getUserAuth ------userToken', userToken)
              console.log('getUserAuth ------openId', openId)
              store.commit('userToken', userToken)
              store.commit('openId', openId)
              resolve(res)
            }).catch((err) => {
              reject(err)
            })
          } else {
            auth()
          }
        } else if (window.isAlipay) {
          source = 3
          let urlObj = aLiurlParse()
          // let auth_code = urlObj.auth_code || ''
          const {auth_code = '', storeId = '', brandId = '', linkNO = '', amount = ''} = urlObj
          store.commit('brandIdStr', brandId)
          store.commit('storeIdStr', storeId)
          store.commit('linkNO', linkNO)
          store.commit('amount', amount ? (amount / 100) : '')
          if (!auth_code) {
            auth()
          } else {
            getUserAuth(auth_code, source).then((res) => {
              console.log('code', res)
              const { userToken, openId } = res.data
              console.log('getUserAuth ------userToken', userToken)
              console.log('getUserAuth ------openId', openId)
              store.commit('userToken', userToken)
              store.commit('openId', openId)
              resolve(res)
            }).catch((err) => {
              reject(err)
            })
          }
        }
      } else {}
    }
  })
}
export default login
